<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Bericht</h1>
                <p class="h2">...und den Erfolg mit dem Arzt oder der Ärztin teilen? Aber sicher! Nutzende sind stolz auf ihre Erfolge</p>
            </div>
            <div class="right-wrapper">
                <h2>Patientenbericht</h2>                
                <p class="text">Für das Praxis-Team ist es oft schwierig, die Fortschritte der Patientinnen und Patienten zwischen den Besuchen zu verfolgen.</p>
                <p class="text">Jetzt nicht mehr:</p>
                <p class="text">Bitten Sie den Patienten oder die Patientin einfach, einen zusammenfassenden Bericht über den Zeitraum zwischen den Besuchen zu erstellen.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 24
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>